/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import { withStyles, createTheme, ThemeProvider } from "@material-ui/core";

import PDFViewer from "../PDF/PDFViewer";
import HTMLViewer from "../HTML/HTMLViewer";
import TextFileViewer from "../TEXT/TextFileViewer";
import ImageViewer from "../IMAGE/ImageViewer";

import { Fab, Tooltip } from '@material-ui/core'
import { AttachFile } from '@material-ui/icons'


const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = theme => ({
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
})

class DOCViewer extends Component {
  state = {};

  componentDidUpdate() {
    console.log("Doc Viewer Props Updated");
  }

  getSubType = () => {
    try {
      let subType;
      //if group is not null then look in group
      if (this.props.record.group) {
        subType = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_content_type.sub_type;
      } else {
        subType = this.props.record.iu_record_src_info.iu_content_type.sub_type;
      }
      return subType;
    } catch (err) {
      console.log(err);
      return "";
    }
  };

  //get location
  getLocation = () => {
    try {
      let location;
      //if group is not null then look in group
      if (this.props.record.group) {
        location = this.props.record.group[this.props.location_index]
          .iu_record_src_info.iu_record_nav_info.location.position;
      } else {
        location = this.props.record.iu_record_src_info.iu_record_nav_info
          .location.position;
      }
      return location;
    } catch (err) {
      console.log(err);
      return "";
    }
  };

  renderViewer = () => {
    console.log(this.props);
    let sub_type = this.getSubType();
    let location = this.getLocation();
    console.log("doc viewr render", location, sub_type);
    let file_name;
    file_name = this.props.record.source_link.src_file_name

    if (sub_type === "doc" || sub_type === "docx" || sub_type === "html") {
      let drl_url =
        this.props.drl_url +
        "/" +
        this.props.drl_result.file_link.split("/")[0];
      console.log("DRL URL For HTML Viewer :", drl_url);

      return (
        <HTMLViewer
          key={sub_type}
          url={this.props.drl_url + "/" + this.props.drl_result.file_link}
          location={"del-location-" + location}
          height={this.props.height}
          drl_url={drl_url}
          file_name={file_name}
          params = {this.props.params}
          downloadUrl={
            this.props.drl_url + "/" + this.props.drl_result.src_file_link
          }
        />
      );
    }

    if (sub_type === "pdf" || sub_type === "ppt" || sub_type === "pptx") {
      return (
        <PDFViewer
          key={file_name}
          // instance = {{
          //     src : this.props.drl_url + '/' + this.props.drl_result.file_link,
          //     filename : file_name,
          //     width : this.props.width,
          //     height : this.props.height,
          //     page_number : parseInt(this.props.record.iu_record_src_info.iu_record_nav_info.location.position),
          //     downloadUrl : this.props.drl_url + '/' + this.props.drl_result.file_link,  /* Hardcoding the download url */
          //     highlight : ""
          // }}
          src={this.props.drl_url + "/" + this.props.drl_result.file_link}
          filename={file_name}
          file_type={sub_type}
          width={this.props.width}
          height={this.props.height}
          pageNumber={parseInt(location)}
          downloadUrl={
            this.props.drl_url + "/" + this.props.drl_result.src_file_link
          } /* Hardcoding the download url */
          search_string={this.props.search_string}
          params = {this.props.params}
        />
      );
    }

    if (sub_type === "txt") {
      return (
        <TextFileViewer
          file_name={file_name}
          height={this.props.height}
          url={this.props.drl_url + "/" + this.props.drl_result.file_link}
          params = {this.props.params}
          downloadUrl={
            this.props.drl_url + "/" + this.props.drl_result.src_file_link
          }
        />
      );
    }
  };

  render() {
    const { classes } = this.props
    return (
      <ThemeProvider theme = {blue_theme}>
        <div
          style={{
            width: this.props.width,
            height: this.props.height,
            backgroundColor: "#FAFBFC",
            // overflow: "scroll",
          }}
        >
          {this.renderViewer()}
          {/* {
            <Tooltip title = "Attach File">
              <Fab
                className = {classes.fab}
                color = 'primary'
              >
                <AttachFile/>
              </Fab>
            </Tooltip>
          } */}
        </div>
      </ThemeProvider>
    );
  }
}

export default withStyles(styles)(DOCViewer);
